import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import FlagIcon from "../assets/icons/india-icon.png";
import FlagIconBn from "../assets/icons/bangladesh-flag-round-circle-icon.png";
import { isEmpty } from "lodash";
import AuthContext from "../context/AuthContext";
import { useTranslation } from "react-i18next";
import { footerAccountMenu } from "../Utils/constants";

const FooterNew = () => {
  const { user, lang, setEn, setBr } = useContext(AuthContext);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [activePage, setActivePage] = useState('Home');
  const location = useLocation();
  const currentPath = location.pathname;
  const [select, setSelect] = useState("home");
  // Sync footer active state with current route (fixes wrong highlight on refresh / direct nav)
  useEffect(() => {
    const path = location.pathname;
    if (path === "/sports") setSelect("sports");
    else if (path === "/inplay") setSelect("inplay");
    else if (path === "/userhome" || path === "/home" || path === "/") setSelect("home");
    else if (path === "/multiMarket") setSelect("multi");
    else if (path === "/profile" || path === "/login") setSelect("account");
  }, [location.pathname]);

  const handleReferralClick = () => {
    if (isEmpty(user)) {
      navigate('/login');
      return;
    }
    navigate('/refer');
    setActivePage('Referral');
  };

  const handleAccountClick = () => {
    if (isEmpty(user)) {
      navigate('/login');
      return;
    }
    navigate('/new-profile');
    setActivePage('Account');
  };
  const handleSelect = (p) => {
    setSelect(p);
  };

  return (
    <div className="">
      <ul>
        <div className="" >
          <nav className=" defaultFooter" style={{left: '0px'}}>
            <ul className="" style={{display: 'flex', justifyContent: 'space-between'}}>
            <li id="mini" className="game-nav">
            <a
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {
                  setGameFooter(true);
                } else {
                  navigate("/login");
                }
              }}
              neua="Sports"
              className="ui-link"
            >
              <img
                className="icon-promote"
                src={
                  // process.env.REACT_APP_MOBILE_URL +
                  "/assets/images/home/promot.svg"
                }
                alt=""
              />
            </a>
          </li>
              <li id="sports" className={` ${currentPath === "/sports" ? 'active' : ''}`}>
                <Link
                  to="/sports"
                  neua="Sports"
                  className="ui-link"
                >
                  <img
                    className="icon-sports"
                    src="/assets/images/transparent.gif"
                    alt=""
                  />
                  Sports
                </Link>
              </li>
              <li id="inPlay" className={` ${currentPath === "/inplay" ? 'active' : ''}`}>
                <Link to="/inplay" neua="In-Play" className="ui-link">
                  <img
                    className="icon-inplay"
                    src="/assets/images/transparent.gif"
                    alt=""
                  />
                  In-Play
                </Link>
              </li>
              <li id="home" className={`main-nav ${currentPath === "/" ? 'active' : ''}`}
                onClick={() => setActivePage('Home')}>
                <Link neua="Home" to="/">
                  <img
                    className="icon-home"
                    src="/assets/images/transparent.gif"
                    alt=""
                  />
                  Home
                </Link>
              </li>
              <li id="multiMarket1"
                onClick={() => {handleSelect("multi");setParly(false);}}>
                <Link className="ui-link" to="/inplay" neua="multi">
                  <img
                    className="icon-pin"
                    src="/assets/images/transparent.gif"
                    alt=""
                  />
                  Multi
                </Link>
              </li>
              <li id="account" className={`main-nav ${currentPath === "/myaccount" ? 'active' : ''}`}
                onClick={handleAccountClick}>
                <Link className="ui-link" to="#!">
                  <img
                    className="icon-account"
                    src="/assets/images/transparent.gif"
                    alt=""
                  />
                  Account
                </Link>
              </li>
            </ul>
          </nav>
          {/* <nav className=" defaultFooter" style={{left: '0px'}}>
        <ul
          className="" style={{display: 'flex', justifyContent: 'space-between'}}
        >
         
          <li id="mini" className="game-nav">
            <a
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {
                  setGameFooter(true);
                } else {
                  navigate("/login");
                }
              }}
              neua="Sports"
              className="ui-link"
            >
              <img
                className="icon-promote"
                src={
                  // process.env.REACT_APP_MOBILE_URL +
                  "/assets/images/home/promot.svg"
                }
                alt=""
              />
            </a>
          </li>
          <li id="sports" className={select == "sports" ? "active" : ""}>
            <Link
              to="/sports"
              neua="Sports"
              className={select == "sports" ? "ui-link active" : "ui-link"}
              onClick={() => {handleSelect("sports");setParly(false);}}
            >
              <img
                className="icon-sports"
                src={
                  // import.meta.env.VITE_IMAGE_URL +
                  "/assets/images/home/transparent.gif"
                }
                alt=""
                // src={import.meta.env.VITE_IMAGE_URL + '/yourPathHere.jpg' }
              />
              Sports
            </Link>
          </li>

          <li id="inPlay" className={select == "inplay" ? "active" : ""}>
           
            <Link
              to="/inplay"
              neua="In-Play"
              className={select == "inplay" ? "ui-link active" : "ui-link"}
              onClick={() => {handleSelect("inplay");setParly(false);}}
            >
              <img
                className="icon-inplay"
                src={
                  // import.meta.env.VITE_IMAGE_URL +
                  "/assets/images/home/transparent.gif"
                }
                alt=""
              />
              In-Play
            </Link>
     
          </li>

          <li
            id="home"
            className={select == "home" ? "main-nav active" : "main-nav"}
            onClick={() => {handleSelect("home");setParly(false);}}
          >
            <Link to="/userhome" neua="Home">
              <img
                className="icon-home"
                src={
                  // import.meta.env.VITE_IMAGE_URL +
                  "/assets/images/home/transparent.gif"
                }
                alt=""
              />
              Home
            </Link>
          </li>
          <li id="multiMarket1" className={select == "multi" ? "active" : ""}>
              <Link
              to="/inplay"
              neua="multi"
              className={select == "multi" ? "ui-link active" : "ui-link"}
              onClick={() => {handleSelect("multi");setParly(false);}}
            >
              <img
                className="icon-pin"
                src={
                  "/assets/images/home/transparent.gif"
                }
                alt=""
              />
              Multi
            </Link>
          </li>

          <li id="account">
            <Link
              to={user ? "/profile" : "/login"}
              className={select == "account" ? "ui-link active" : "ui-link"}
              onClick={() => {handleSelect("account");setParly(false);}}
            >
              <img
                className="icon-account"
                src={
                  // import.meta.env.VITE_IMAGE_URL +
                  "/assets/images/home/transparent.gif"
                }
                alt=""
              />
              Account
            </Link>
          </li>
        </ul>
      </nav> */}
        </div>
      </ul>
    </div>
  );
};

export default FooterNew;